import Vue from 'vue';
import Vuex from 'vuex';

/** Global store */
import app from '@/store/config.store';
import auth from '@/store/auth.store';

import article from '@/store/article.store';

/** RH store */
import offreEmploi from '@/store/rh/offre-emploi.store';
import candidature from '@/store/rh/candidature.store';
import employe from '@/store/rh/employe.store';
import formation from '@/store/rh/formation.store';
import formationSession from '@/store/rh/formation-session.store';
import profilParticipant from '@/store/rh/profil-participant.store';

import checklist from '@/store/rh/checklist.store';
import entretien from '@/store/rh/entretien.store';

import tiers from '@/store/tiers.store';
import echange from '@/store/echange.store';
import chantier from '@/store/chantier.store';
import nettoyage from '@/store/nettoyage.store';
import absence from '@/store/absence.store';
import remplacement from '@/store/remplacement.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    /** Global */
    app,
    auth,
    /**Achat */
    article,

    /** RH */
    offreEmploi,
    candidature,
    employe,
    formation,
    formationSession,
    profilParticipant,
    checklist,
    entretien,

    tiers,
    echange,
    chantier,
    nettoyage,
    absence,
    remplacement,
  },
});
